import { type TFunction } from "i18next"

/**
 * `EducationFieldView.value` is `unknown` on the wire — the snapshot mixes
 * plain strings, booleans (e.g. `needs_permit`) and the occasional list.
 * Returns `null` for "nothing to show" so callers (the Screen 1 summary
 * rows, the Review Inputs table) can each choose their own empty copy
 * ("Not provided" vs. "—") instead of this helper picking one for both.
 */
export const formatEducationFieldValue = (value: unknown, t: TFunction): string | null => {
  if (value === null || value === undefined || value === "") return null

  if (Array.isArray(value)) {
    const items = value.filter((item) => item !== null && item !== undefined && item !== "")
    return items.length ? items.map(String).join(", ") : null
  }

  if (typeof value === "boolean") {
    return value ? t("projectEducation.common.yes") : t("projectEducation.common.no")
  }

  return String(value)
}
